import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
export function TransformationSection() {
  const {
    t
  } = useLanguage();
  return <section className="py-10 bg-beige-light border-y border-gold/20" data-id="element-417">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-418">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} className="bg-white p-8 md:p-12 rounded-sm shadow-xl border border-gold/30 relative" data-id="element-419">
          <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-white p-3 rounded-full border border-gold/30 shadow-sm" data-id="element-420">
            <Sparkles className="w-6 h-6 text-gold" data-id="element-421" />
          </div>

          <h2 className="text-3xl font-serif font-bold text-center text-dark mb-8 mt-4" data-id="element-422">
            {t('transformation', 'title')}
          </h2>

          <div className="space-y-6 text-lg text-dark/80 text-center" data-id="element-423">
            <p data-id="element-424">{t('transformation', 'imagine')}</p>
            <p data-id="element-425">{t('transformation', 'listen')}</p>
            <p className="font-medium text-dark" data-id="element-426">
              {t('transformation', 'noGuesses')}
            </p>
            <p data-id="element-427">{t('transformation', 'plan')}</p>
            <p className="text-xl font-serif text-gold-dark font-medium pt-4" data-id="element-428">
              {t('transformation', 'reality')}
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}